import React from 'react';

function IncluirNoDispobibles({ mostrarNoDisponible, setMostrarNoDisponible,setFiltros,donde }) {
  const handleChange = (e) => {
    setMostrarNoDisponible(e.target.checked); 
    if (donde === "mostratodo") {
      setFiltros((prevFiltros) => ({
        ...prevFiltros,
        mostrarNoDisponible: e.target.checked,
      }));
    }
  };

  return (
    <div className='w-full mt-3 flex justify-between items-center p-1 xl:p-2'>
      <label className='font-bold text-sm xl:text-base'>Incluir no disponibles</label>
      <div className="flex items-center">
        <label className="relative inline-flex items-center cursor-pointer">
          <input
            type="checkbox"
            className="sr-only peer"
            checked={mostrarNoDisponible}
            onChange={handleChange} 
          />
          <div className="w-11 h-6 bg-GrisOscuro peer-focus:outline-none peer-focus:ring-0 rounded-full peer peer-checked:bg-Verde peer-checked:after:translate-x-full after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:after:border-white"></div>
        </label>
      </div>
    </div>
  );
}

export default IncluirNoDispobibles;
